// Contact.jsx
import React from 'react';
import './Contact.css'; // 👈 Import the CSS file

const Contact = ({ companyData }) => {
  // Clean the phone number (removes spaces, +, etc.)
  const phone = companyData.phone ? companyData.phone.replace(/\D/g, '') : '';
  const whatsappUrl = `https://wa.me/${phone}`; // Standard link format

  return (
    <section id="contact" className="contact-section">
      <div className="contact-content">
        <h2 className="section-title">Get In Touch</h2>
        <p className="section-subtitle">Ready to start your project? Let's talk.</p>

        <div className="contact-grid">
          {/* --- Contact Form --- */}
          <form className="contact-form">
            <h3>Send Us a Message</h3>
            <input type="text" name="name" placeholder="Your Name" required />
            <input type="email" name="email" placeholder="Your Email" required />
            <textarea name="message" placeholder="Your Message" rows="5" required></textarea>
            {/* Note: For a real deployment, this form needs a backend endpoint */}
            <button type="submit" className="btn btn-primary">Send Message</button>
          </form>

          {/* --- Contact Info & WhatsApp --- */}
          <div className="contact-info">
            <h3>Devulex Details</h3>
           
            <p className="contact-detail">
              Phone: {companyData.phone}
            </p>
         <p 
  className="contact-detail location"
  style={{
    textAlign: 'left', // 👈 Inline CSS for justification
    fontSize: '1em',
    lineHeight: '1.8',
    marginBottom: '20px',
    color: '#fff' // Ensure this matches your desired color, or remove if using external CSS
  }}
>
  Location: {companyData.location || "Available Globally"}
</p>
            <div className="contact-cta">
              <h4>Direct Chat</h4>
              {/* WHATSAPP BUTTON */}
              <a 
                href={whatsappUrl} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="btn-whatsapp"
              >
                Start WhatsApp Chat
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;